import { filter } from '../utils/collection.utils';
import { ChangedItem } from './changed-item';

const getChangesByAttribute = (changes: ChangedItem[], attribute: string) => filter(item => item.changedAttribute === attribute, changes);

export class ChangedAttribute {
  constructor(
    public fileName: string,
    public changes: ChangedItem[]
  ) { }

  get isNew() {
    return getChangesByAttribute(this.changes, 'NEW_MATERIAL').length > 0;
  }

  get isDeleted() {
    return getChangesByAttribute(this.changes, 'DELETED_MATERIAL').length > 0;
  }
}




// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/changed-attribute.ts